"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./UserLocatorButton.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const UserLocatorButton = _ref => {
  let {
    mapRef,
    maps,
    onError
  } = _ref;
  const marker = (0, _react.useRef)(null);
  const accuracyCircle = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    getUserLocation(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const blueDot = {
    path: maps.SymbolPath.CIRCLE,
    fillColor: '#4285F4',
    fillOpacity: 1,
    scale: 8,
    strokeColor: 'rgb(255,255,255)',
    strokeWeight: 2
  };
  const handleGeolocationError = error => {
    if (error.code === 1) {
      var _marker$current, _accuracyCircle$curre;
      (_marker$current = marker.current) === null || _marker$current === void 0 ? void 0 : _marker$current.setMap(null);
      (_accuracyCircle$curre = accuracyCircle.current) === null || _accuracyCircle$curre === void 0 ? void 0 : _accuracyCircle$curre.setMap(null);
    }
    onError && onError(error.code);
  };
  const getUserLocation = panToUser => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        var _accuracyCircle$curre2;
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        if (panToUser) {
          var _mapRef$current, _mapRef$current$getZo, _mapRef$current2;
          (_mapRef$current = mapRef.current) === null || _mapRef$current === void 0 ? void 0 : _mapRef$current.panTo(userLocation);
          if ((_mapRef$current$getZo = (_mapRef$current2 = mapRef.current) === null || _mapRef$current2 === void 0 ? void 0 : _mapRef$current2.getZoom()) !== null && _mapRef$current$getZo !== void 0 ? _mapRef$current$getZo : 0 < 14) {
            var _mapRef$current3;
            (_mapRef$current3 = mapRef.current) === null || _mapRef$current3 === void 0 ? void 0 : _mapRef$current3.setZoom(14);
          }
        }
        if (marker.current) {
          marker.current.setMap(null);
        }
        marker.current = new maps.Marker({
          icon: blueDot,
          position: userLocation
        });
        marker.current.setMap(mapRef.current);
        const errorRange = position.coords.accuracy;
        if (accuracyCircle.current) {
          accuracyCircle.current.setMap(null);
        }
        accuracyCircle.current = new maps.Circle({
          center: userLocation,
          fillColor: '#61a0bf',
          fillOpacity: 0.4,
          radius: errorRange,
          strokeColor: '#1bb6ff',
          strokeOpacity: 0.4,
          strokeWeight: 1,
          zIndex: 1
        });
        (_accuracyCircle$curre2 = accuracyCircle.current) === null || _accuracyCircle$curre2 === void 0 ? void 0 : _accuracyCircle$curre2.setMap(mapRef.current);
      }, error => {
        handleGeolocationError(error);
      }, {
        maximumAge: 5000
      });
    } else {
      // code for legacy browsers
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "center-on-me",
    onClick: () => getUserLocation(true)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gmapcontainer"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "28",
    viewBox: "0 0 48 48",
    className: "locatemelogo"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h48v48h-48z",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 16c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm17.88 6c-.92-8.34-7.54-14.96-15.88-15.88v-4.12h-4v4.12c-8.34.92-14.96 7.54-15.88 15.88h-4.12v4h4.12c.92 8.34 7.54 14.96 15.88 15.88v4.12h4v-4.12c8.34-.92 14.96-7.54 15.88-15.88h4.12v-4h-4.12zm-17.88 16c-7.73 0-14-6.27-14-14s6.27-14 14-14 14 6.27 14 14-6.27 14-14 14z"
  }))));
};
var _default = UserLocatorButton;
exports.default = _default;